// This file was auto-generated by querybuilder/Apollo and should not be edited.

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: HarassmentDetails
// ====================================================

export interface HarassmentDetails {
  /**
   * Does you building have 2 apartments or less?
   */
  twoOrLessApartmentsInBuilding: boolean | null;
  /**
   * Is there more than one family living in each apartment?
   */
  moreThanOneFamilyPerApartment: boolean | null;
  /**
   * Explain how the landlord has harassed you.
   */
  harassmentDetails: string;
  /**
   * Whether the tenant alleges the landlord has FORCE.
   */
  allegForce: boolean;
  /**
   * Whether the tenant alleges the landlord has MISLEADING_INFO.
   */
  allegMisleadingInfo: boolean;
  /**
   * Whether the tenant alleges the landlord has STOPPED_SERVICE.
   */
  allegStoppedService: boolean;
  /**
   * Whether the tenant alleges the landlord has FAILED_TO_COMPLY.
   */
  allegFailedToComply: boolean;
  /**
   * Whether the tenant alleges the landlord has FALSE_CERT_REPAIRS.
   */
  allegFalseCertRepairs: boolean;
  /**
   * Whether the tenant alleges the landlord has CONDUCT_IN_VIOLATION.
   */
  allegConductInViolation: boolean;
  /**
   * Whether the tenant alleges the landlord has SUED.
   */
  allegSued: boolean;
  /**
   * Whether the tenant alleges the landlord has REMOVED_POSSESSIONS.
   */
  allegRemovedPossessions: boolean;
  /**
   * Whether the tenant alleges the landlord has INDUCED_LEAVING.
   */
  allegInducedLeaving: boolean;
  /**
   * Whether the tenant alleges the landlord has CONTACT.
   */
  allegContact: boolean;
  /**
   * Whether the tenant alleges the landlord has THREATS_RE_STATUS.
   */
  allegThreatsReStatus: boolean;
  /**
   * Whether the tenant alleges the landlord has REQUESTED_ID.
   */
  allegRequestedId: boolean;
  /**
   * Whether the tenant alleges the landlord has DISTURBED.
   */
  allegDisturbed: boolean;
}

export const BlankHarassmentDetails: HarassmentDetails = {
  "twoOrLessApartmentsInBuilding": null,
  "moreThanOneFamilyPerApartment": null,
  "harassmentDetails": "",
  "allegForce": false,
  "allegMisleadingInfo": false,
  "allegStoppedService": false,
  "allegFailedToComply": false,
  "allegFalseCertRepairs": false,
  "allegConductInViolation": false,
  "allegSued": false,
  "allegRemovedPossessions": false,
  "allegInducedLeaving": false,
  "allegContact": false,
  "allegThreatsReStatus": false,
  "allegRequestedId": false,
  "allegDisturbed": false
};

export const graphQL = `# This file was auto-generated by querybuilder, please do not edit it.
fragment HarassmentDetails on HarassmentDetailsType {
  twoOrLessApartmentsInBuilding,
  moreThanOneFamilyPerApartment,
  harassmentDetails,
  allegForce,
  allegMisleadingInfo,
  allegStoppedService,
  allegFailedToComply,
  allegFalseCertRepairs,
  allegConductInViolation,
  allegSued,
  allegRemovedPossessions,
  allegInducedLeaving,
  allegContact,
  allegThreatsReStatus,
  allegRequestedId,
  allegDisturbed
}`;